/*
 * File: PreferenceFields.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Model representing the list of "app-wide" preferences
 * We're seperating them out in the event that we might want
 * to add specific preferences to specific pages in the future
 */

import General from "./models/GeneralPreferences";
import Security from "./models/SecurityPreferences";
import Scheduling from "./models/SchedulingPreferences";
import Billing from "./models/BillingPreferences";

const PreferenceFields = [...General, ...Security, ...Scheduling, ...Billing];

export default PreferenceFields;
